/**
 * CooldownDisplay.jsx - Shows movement and expedition cooldowns
 */

import React from 'react';

export function CooldownDisplay({
  moveOnCooldown,
  moveCooldown,
  expeditionProgress
}) {
  // Don't render anything if there's nothing to show
  const showMoveCooldown = !expeditionProgress && moveOnCooldown;
  const showExpedition = expeditionProgress;

  if (!showMoveCooldown && !showExpedition) {
    return null;
  }

  return (
    <div className="wm-cooldowns">
      {showMoveCooldown && (
        <div className="wm-cd move active">
          <span>Move</span>
          <span>{(moveCooldown / 1000).toFixed(1)}s</span>
        </div>
      )}
      {showExpedition && (
        <div className="wm-cd expedition active">
          <span>🏕️ Expedition</span>
          <span>{expeditionProgress.formattedRemaining}</span>
        </div>
      )}
    </div>
  );
}

export default CooldownDisplay;
